import _classCallCheck from "C:\\Users\\wgharbi\\Desktop\\wejdi Github\\my portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\wgharbi\\Desktop\\wejdi Github\\my portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\wgharbi\\Desktop\\wejdi Github\\my portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\wgharbi\\Desktop\\wejdi Github\\my portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\wgharbi\\Desktop\\wejdi Github\\my portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import PropTypes from "prop-types";
import { initialConfig } from "./config";
import { TypingStep as LibTypingStep } from "./LibTypingStep";
/**
 * @class TypingStep
 * An UI Component to render fully customisable Typing Effect
 *
 * @param {string || array} sequence
 *  An array of commands to be executed
 *      @param {string || number} content
 *          The command to be executed.
 *          * String denotes add command
 *          * Positive number denotes delay command
 *          * Negative number denotes number of characters to delete
 *      @param {object} config
 *          Set of local configurations that overrides global config
 *             @param {number} typeSpeed
 *             @param {string} styleClass
 *             @param {number} letterSpacing
 *             @param {number} cursorThickness
 *             @param {string} cursorColor
 *             @param {number} cursorPadding
 *             @param {number} deleteSpeed
 *             @param {number} blinkingSpeed
 * @param {number} typeSpeed
 *  Typing speed in milliseconds
 * @param {boolean} ignoreInitialDelay
 *  Whether to start with empty render or first letter already rendered
 * @param {string || React Element} element
 *  HTML Element or an user defined React Component
 * @param {string} styleClass
 *  Optional style class to be passed along with the text
 * @param {number} letterSpacing
 *  Space between each letter
 * @param {number} cursorThickness
 *  Thickness of the cursor
 * @param {string} cursorColor
 *  Color of the cursor
 * @param {number} cursorPadding
 *  Distance between last word and cursors
 * @param {number} deleteSpeed
 *  Delete speed in milliseconds
 * @param {number} blinkingSpeed
 *  Blinking speed of cursor in milliseconds
 * @param {boolean || number} disableBlinkingOnEnd
 *  Disable blinking on end or wait for a few blinks
 */

var TypingStep =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TypingStep, _React$Component);

  // eslint-disable-next-line no-useless-constructor
  function TypingStep(props) {
    _classCallCheck(this, TypingStep);

    return _possibleConstructorReturn(this, _getPrototypeOf(TypingStep).call(this, props));
  }

  _createClass(TypingStep, [{
    key: "render",
    value: function render() {
      var sequence = this.props.sequence;
      return (
        /*#__PURE__*/
        React.createElement(LibTypingStep, _extends({}, this.props, {
          key: sequence
        }))
      );
    }
  }]);

  return TypingStep;
}(React.Component);

TypingStep.propTypes = {
  sequence: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    config: PropTypes.shape({
      typeSpeed: PropTypes.number,
      styleClass: PropTypes.string,
      letterSpacing: PropTypes.number,
      cursorThickness: PropTypes.number,
      cursorColor: PropTypes.string,
      cursorPadding: PropTypes.number,
      deleteSpeed: PropTypes.number,
      blinkingSpeed: PropTypes.number
    })
  })).isRequired,
  ignoreInitialDelay: PropTypes.bool,
  disableBlinkingOnEnd: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  typeSpeed: PropTypes.number,
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  styleClass: PropTypes.string,
  letterSpacing: PropTypes.number,
  cursorThickness: PropTypes.number,
  cursorColor: PropTypes.string,
  cursorPadding: PropTypes.number,
  deleteSpeed: PropTypes.number,
  blinkingSpeed: PropTypes.number
};
TypingStep.defaultProps = {
  typeSpeed: initialConfig.typeSpeed,
  ignoreInitialDelay: initialConfig.ignoreInitialDelay,
  element: initialConfig.element,
  styleClass: initialConfig.styleClass,
  letterSpacing: initialConfig.letterSpacing,
  cursorThickness: initialConfig.cursorThickness,
  cursorColor: initialConfig.cursorColor,
  cursorPadding: initialConfig.cursorPadding,
  deleteSpeed: initialConfig.deleteSpeed,
  blinkingSpeed: initialConfig.blinkingSpeed,
  disableBlinkingOnEnd: initialConfig.disableBlinkingOnEnd
};
export { TypingStep };